import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getAboutUsPage = createAsyncThunk('aboutPage/getAboutUsPage', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getAboutUsPage();
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
